import React, {useState, useEffect} from 'react';
import { Box, Button, Divider, Card, CardContent, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import Transaction from './Transaction';

var check=true;
const getLocalItem = () => {
    let items = localStorage.getItem('transactions');
    if(items==null)
    return []
    if(items!=null)
      return JSON.parse(items)
  }
  
  function Balance(props) {
    const [trans,setTrans] = useState('');
    const [amount,setAmount] = useState();
    const [balance,setBalance] = useState(0);
    const [income,setIncome] = useState(0);
    const [expense,setExpense] = useState(0);
    const [data,setData] = useState(getLocalItem);

    const handleSubmit=(e)=>{
        e.preventDefault();
        const newData=[trans,amount];
        setData([...data,newData]);

          if(check===true){
            setIncome(income + parseInt(newData[1]));
            setBalance(balance + parseInt(newData[1]));
            console.log('income is'+ income)
          }
          if(check===false) {
            setExpense(expense + parseInt(newData[1]));
            setBalance(balance - parseInt(newData[1]));
            console.log('expense is ' + expense)
          }
        console.log('balance is' + balance)
        setTrans('')
        setAmount(0)
      }

  useEffect(()=>{
    localStorage.setItem('transactions',JSON.stringify(data))
  },[data])
  return (
    <Grid container spacing={2} marginTop={2}>
      <Grid item xs={12} sm={6}>
       <Box >
        <Card sx={{backgroundColor:'#ffffffa3',height:'80vh'}}>
            <CardContent >
                <Typography variant='h5' sx={{textAlign:'center', fontFamily:'monospace'}}>Your Balance : ₹{balance}</Typography>
                <Divider></Divider>               
                  <Card sx={{padding:'10px', margin:'auto',backgroundColor:'#ffffff00'}}>
                  <Grid container spacing={2}>
                  <Grid item sm={12} md={6}>
                  <Typography variant='h5' sx={{color :"green", fontFamily:'monospace'}}>Income : ₹{income}</Typography>
                  </Grid>
                  <Grid item sm={12} md={6}>
                  <Typography variant='h5' sx={{color :"#ad0000", fontFamily:'monospace'}}>Expense : ₹{expense}</Typography>
                  </Grid>
                  </Grid>
                  </Card> 
                  <form onSubmit={handleSubmit}>         
                <Box>
                    <TextField required label='Enter Transaction' margin='normal'
                    fullWidth value={trans}
                    onChange={(e)=>{setTrans(e.target.value);}}></TextField><br/>
                    <TextField type='number' required label='Enter Amount' 
                   margin='normal' fullWidth 
                   value={amount}
                    onChange={(e)=>{setAmount(e.target.value);}}></TextField>
                </Box>
                <Box>
                  <RadioGroup>
                  <FormControlLabel id='income' value="income" control={<Radio required color="success"/>} label="Income" onClick={()=>{check=true;}}/>
                  <FormControlLabel id='expense' value="expense" control={<Radio required color="error"/>} label="Expense" onClick={()=>{check=false;}}/>
                  </RadioGroup>
                </Box>
                <Button variant='contained' sx={{marginTop:'20px'}} type='submit'>ENTER</Button>
                </form>
            </CardContent>
        </Card>
        
    </Box>
    </Grid>
    <Grid item xs={12} sm={6}>
    <Box>
        <Card sx={{backgroundColor:'#ffffffa3',height:'80vh'}}>
        <CardContent>
        
        <Typography variant='h5' sx={{textAlign:'center', fontFamily:'monospace'}}>Transaction Details</Typography>
        <Divider></Divider>
        <Card sx={{backgroundColor:'#ffffff00',height:'70vh', overflow:'auto'}}>
        {
        data.map((value,index)=>{
          return(
            <Transaction 
              key={index.toString()}
              id={index}
              val={value}
              check={check}></Transaction>
          )
        })
      }
        </Card>
      </CardContent>
        </Card>
        </Box>
    </Grid>
    </Grid>
  )
}

export default Balance